export * from './rechnung-geloescht.interface';
